export enum CompaniesActionType {
  SET_COMPANIES = 'SET_COMPANIES',
  SET_COMPANIES_AFTER_SCROLL = 'SET_COMPANIES_AFTER_SCROLL',
  SET_CERTAIN_COMPANY = 'SET_CERTAIN_COMPANY',
  SET_COMPANIES_LOADING_STATUS = 'SET_COMPANIES_LOADING_STATUS',
  SEARCH_COMPANIES = 'SEARCH_COMPANIES',
  SET_COMPANIES_PAGINATION = 'SET_COMPANIES_PAGINATION',
}
